import {
    FETCH_PRODUCT_HOTEL_REQUEST,
    FETCH_PRODUCT_HOTEL_SUCCESS,
    FETCH_PRODUCT_HOTEL_FAILURE,
    ADD_PRODUCT_HOTEL_REQUEST,
    ADD_PRODUCT_HOTEL_SUCCESS,
    ADD_PRODUCT_HOTEL_FAILURE,
    UPDATE_PRODUCT_HOTEL_REQUEST,
    UPDATE_PRODUCT_HOTEL_SUCCESS,
    UPDATE_PRODUCT_HOTEL_FAILURE,
    DELETE_PRODUCT_HOTEL_REQUEST,
    DELETE_PRODUCT_HOTEL_SUCCESS,
    DELETE_PRODUCT_HOTEL_FAILURE,
  } from '../action/productHotelActions'; // Pastikan path ini sesuai
  
  const initialState = {
    productsHotels: [],  // Menggunakan productsHotels
    loading: false,
    error: null,
  };
  
  const productHotelReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PRODUCT_HOTEL_REQUEST:
        return { ...state, loading: true };
      case FETCH_PRODUCT_HOTEL_SUCCESS:
        return { ...state, loading: false, productsHotels: action.payload }; // Ganti ProductHotels dengan productsHotels
      case FETCH_PRODUCT_HOTEL_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case ADD_PRODUCT_HOTEL_REQUEST:
        return { ...state, loading: true };
      case ADD_PRODUCT_HOTEL_SUCCESS:
        return {
          ...state,
          loading: false,
          productsHotels: [...state.productsHotels, action.payload], // Ganti ProductHotels dengan productsHotels
        };
      case ADD_PRODUCT_HOTEL_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case UPDATE_PRODUCT_HOTEL_REQUEST:
        return { ...state, loading: true };
      case UPDATE_PRODUCT_HOTEL_SUCCESS:
        return {
          ...state,
          loading: false,
          productsHotels: state.productsHotels.map((product) =>
            product.id === action.payload.id ? action.payload : product // Ganti ProductHotels dengan productsHotels
          ),
        };
      case UPDATE_PRODUCT_HOTEL_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case DELETE_PRODUCT_HOTEL_REQUEST:
        return { ...state, loading: true };
      case DELETE_PRODUCT_HOTEL_SUCCESS:
        return {
          ...state,
          loading: false,
          productsHotels: state.productsHotels.filter((product) => product.id !== action.payload), // Ganti ProductHotels dengan productsHotels
        };
      case DELETE_PRODUCT_HOTEL_FAILURE:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default productHotelReducer;
  